// Icon: Loading
// 

JLM.MD.IconLoading = function( container ) {
	
	const INSTANCE = {};
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let element;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let icon;
		
		// Build
		element = $('<div class="icon_loading" />').appendTo( container );
		icon = $('<svg><use xlink:href="#jl_icon_loading"></use></svg>').appendTo( element );
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Remove
	// 
	INSTANCE.remove = function() {
		if ( element ) element.remove();
		element = null;
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};